import { gql } from 'urql'

export const querySubprincipleConfigs = gql`
  query ($offset: Int!, $limit: Int!) {
    subprinciple_config(
      offset: $offset
      limit: $limit
      order_by: [{ subprinciple_config_name_locale: asc }, { id: asc }]
    ) {
      id
      subprinciple_config_name_locale
      active
      principle_config {
        names
      }
    }
    subprinciple_config_aggregate {
      aggregate {
        count
      }
    }
  }
`

export const querySubprincipleConfigById = gql`
  query ($subprincipleId: Int!) {
    subprinciple_config(where: { id: { _eq: $subprincipleId } }) {
      id
      names
      active
      principle_config_id
      descriptions
      help_and_instruction_key
      kap_program_subprinciples_aggregate(
        where: { _or: [{ concept_comment: { _is_null: false } }, { implementation_comment: { _is_null: false } }] }
      ) {
        aggregate {
          count
        }
      }
    }
  }
`

export const insertSubprincipleConfig = gql`
  mutation ($subprincipleInsertInput: [subprinciple_config_insert_input!]!) {
    insert_subprinciple_config(objects: $subprincipleInsertInput) {
      affected_rows
    }
  }
`

export const updateSubprincipleConfigById = gql`
  mutation ($subprincipleId: Int!, $subprincipleSetInput: subprinciple_config_set_input!) {
    update_subprinciple_config(where: { id: { _eq: $subprincipleId } }, _set: $subprincipleSetInput) {
      affected_rows
    }
  }
`

export const updateSortOnSubprincipleConfig = gql`
  mutation (
    $firstWhere: subprinciple_config_bool_exp!
    $secondWhere: subprinciple_config_bool_exp!
    $setClause1: subprinciple_config_set_input!
    $setClause2: subprinciple_config_set_input!
  ) {
    updateFirst: update_subprinciple_config(where: $firstWhere, _set: $setClause1) {
      affected_rows
    }

    updateSecond: update_subprinciple_config(where: $secondWhere, _set: $setClause2) {
      affected_rows
    }
  }
`
